import React from "react";
import { components } from "react-select";
import AsyncSelect from "react-select/async";
import { useDispatch } from "react-redux";
import DownArrowIcon from "../../assets/icons/down-arrow-icon";

const ItemsSearchSelectFieldStandalone = ({
  field = "",
  action = () => {},
  value = {},
  handleChange = () => {},
  isMulti = false,
  placeholder = "Search (/)",
}) => {
  const dispatch = useDispatch();

  const DropdownIndicator = (props) => (
    <components.DropdownIndicator {...props}>
      <DownArrowIcon />
    </components.DropdownIndicator>
  );

  const loadOptions = (inputValue) => {
    return new Promise((resolve) => {
      const onSuccess = (data) => {
        const options = data?.data.map((item) => ({
          value: `${item?.item_id}`,
          label: `${item?.[field]}`,
        }));
        resolve(options);
      };

      const onError = (error) => {
        console.error("Error loading options:", error);
        resolve([]);
      };

      if (inputValue?.length > 0) {
        dispatch(
          action(
            {
              field,
              value: inputValue,
              isVendor: false,
            },
            onSuccess,
            onError
          )
        );
      } else {
        resolve([]);
      }
    });
  };

  return (
    <AsyncSelect
      isMulti={isMulti}
      value={isMulti ? value || [] : value || null}
      onCreateOption={() => {}}
      className="w-full"
      styles={customStyles}
      components={{ ...components, DropdownIndicator }}
      placeholder={placeholder}
      menuPlacement="auto"
      loadOptions={loadOptions}
      onChange={handleChange}
      menuPortalTarget={document.body}
    />
  );
};

export default ItemsSearchSelectFieldStandalone;

const customStyles = {
  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  indicatorSeparator: () => ({ display: "none" }),
  control: (base, state) => ({
    ...base,
    width: "100%",
    height: "32px",
    minHeight: "32px",
    backgroundColor: "var(--stand-alone-input-bg)",
    color: "var(--stand-alone-input-color)",
    fontSize: "var(--stand-alone-input-font-size)",
    fontWeight: "var(--stand-alone-input-font-weight)",
    borderColor: state.isFocused
      ? "var(--stand-alone-input-focus)"
      : "var(--stand-alone-input-border)",
    boxShadow: "none",
    borderRadius: "6px",
    padding: "0",
    margin: "0",
    "&:hover": {
      borderColor: "var(--stand-alone-input-focus)",
    },
  }),
  valueContainer: (base) => ({
    ...base,
  height: "32px",
  padding: "0 4px",
  display: "flex",
  alignItems: "center",
  lineHeight: "32px",  // Add this
  }),
  option: (provided, state) => ({
    ...provided,
    color: "var(--stand-alone-input-color)",
    backgroundColor: state.isSelected
      ? "#e5ecffb2"
      : state.isFocused
      ? "#0000002E"
      : "transparent",
    borderBottom: "1px solid #F5F5F5",
    fontFamily: "Inter, sans-serif",
    fontSize: "var(--stand-alone-place-font-size)",
    fontWeight: "var(--stand-alone-place-font-weight)",
    "&:hover": {
      backgroundColor: "#0000002E",
    },
  }),
  placeholder: (defaultStyles) => ({
    ...defaultStyles,
    position: "absolute",
    left: "8px",
    top: "50%",
    transform: "translateY(-50%)",
    pointerEvents: "none",
    color: "var(--stand-alone-place-color)",
    fontFamily: "Inter, sans-serif",
    fontSize: "var(--stand-alone-place-font-size)",
    fontWeight: "var(--stand-alone-place-font-weight)",
    opacity: "0.6",
  }),
  singleValue: (base) => ({
    ...base,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    color: "var(--stand-alone-input-color)",
    fontSize: "var(--stand-alone-input-font-size)",
    fontWeight: "var(--stand-alone-input-font-weight)",
  }),
  input: (base) => ({
    ...base,
    margin: 0,
    padding: 0,
    color: "var(--stand-alone-input-color)",
    fontSize: "var(--stand-alone-input-font-size)",
    fontWeight: "var(--stand-alone-input-font-weight)",
  }),
  multiValue: (base) => ({
    ...base,
    backgroundColor: "#E5ECFF",
    gap: "5px",
    padding: "0px 6px",
  }),
  dropdownIndicator: (provided) => ({
    display: "none",
  }),
};
